@if (isSpinnerVisible) {
  <div class="app-loading">
    <div class="logo">
      <img width="70px" src="./assets/images/LogoOnly.png" class="login-logo" />
    </div>
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>
}